export default {
  "trail": {
    "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["trail name"])}
  }
}